/**
 * @author: howarchou@sina.com
 * @date: 2018/11/14
 */
import VueCookies from 'vue-cookies'

let USER = {};

export function setAuth(auth) {
    if (!auth) return;
    USER['auth'] = auth;
    return VueCookies.set("lottery-userauth", auth, '1d');
}

export function getAuth() {
    if (USER['auth']) return USER['auth'];
    let auth = VueCookies.get("lottery-userauth");
    return auth ? (USER['auth'] = auth) : '';
}

export function setUserInfo(info) {
    if (!info) return;
    USER['info'] = info;
    return VueCookies.set("lottery-userinfo", USER['info'], '7d');
}

export function getUserInfo() {
    if (USER['info']) return USER['info']
    let info = VueCookies.get("lottery-userinfo");
    return info ? (USER['info'] = info) : null;
}

export function initUser() {
    getAuth();
    getUserInfo();
}

export function removeUser() {
    USER = {};
    VueCookies.remove('lottery-userauth');
}



// WEBPACK FOOTER //
// ./src/config/auth.js